import { useQuery } from "@tanstack/react-query";
import { useLocation } from "wouter";
import { useDean } from "@/contexts/dean-context";
import { deanAccountAccess, type DeanIdentity } from "@/lib/deanChatSession";

export function useDeanAccountAccess() {
  const { data: user } = useQuery<DeanIdentity | null>({
    queryKey: ["/api/auth/me"],
    retry: false,
  });
  const [, navigate] = useLocation();
  const { setIsOpen } = useDean();
  return {
    ...deanAccountAccess(user),
    openDealerPicker: () => {
      // Reuse the existing dealer selector and its server-authorized View as
      // Dealer action, rather than adding another impersonation flow.
      setIsOpen(false);
      navigate("/admin?section=dealers");
    },
  };
}
